import { render } from "./ValueMeter.vue?vue&type=template&id=f004ff3a&scoped=true&bindings={}"
import script from "./ValueMeter.vue?vue&type=script&lang=ts"
export * from "./ValueMeter.vue?vue&type=script&lang=ts"

import "./ValueMeter.vue?vue&type=style&index=0&id=f004ff3a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f004ff3a"

export default script